import { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const MARS_ZONES = [
  {
    id: 'city', label: '奥林匹斯城', icon: 'ri-building-4-line', color: '#FF6B35',
    title: '奥林匹斯城 · 人类第二家园',
    subtitle: 'Olympus City · 2065',
    desc: '位于奥林匹斯山脚下的人类首个火星城市，封闭穹顶直径50公里，内部重力通过旋转结构维持在0.9G，完全模拟地球环境。城市内部绿树成荫，河流潺潺，是真正的火星乌托邦。',
    image: 'https://public.readdy.ai/ai/img_res/ccdd47597770364825132e1d00be3e46.jpg',
    details: [{ label: '穹顶直径', value: '50公里' }, { label: '居住人口', value: '100万' }, { label: '内部重力', value: '0.9G' }, { label: '建设年份', value: '2065年' }],
    scenes: [
      { title: '立体交通网络', desc: 'eVTOL空中走廊、地面磁悬浮、地下超级高铁三层立体交通完美融合，出行时间不超过15分钟', icon: 'ri-flight-takeoff-line' },
      { title: '垂直农业森林', desc: '100层垂直农业大楼，年产粮食满足全城需求，同时提供氧气和调节气候', icon: 'ri-plant-line' },
      { title: '元宇宙生活中心', desc: '所有社交、娱乐、购物、办公都在元宇宙中完成，物理空间只是休息和体验的场所', icon: 'ri-glasses-2-line' },
      { title: '量子能源系统', desc: '核聚变+太阳能双轨供能，城市能源完全自给自足，零碳排放', icon: 'ri-flashlight-line' },
    ],
  },
  {
    id: 'transport', label: '立体交通', icon: 'ri-flight-takeoff-line', color: '#00FFCC',
    title: '三维立体交通 · 无缝出行',
    subtitle: '3D Transport · Zero Accident',
    desc: '火星城市实现了人类历史上最完美的立体交通系统：空中eVTOL走廊、地面磁悬浮轨道、地下超级高铁，三层无缝衔接，AI统一调度，事故率为零。',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20Mars%20city%20transportation%20eVTOL%20flying%20cars%20magnetic%20levitation%20underground%20tunnel%203D%20transport%20system%20cyan%20neon%20glow%20dark%20cinematic%208k&width=1200&height=600&seq=mars-transport-bg-001&orientation=landscape',
    details: [{ label: 'eVTOL航线', value: '2000条' }, { label: '地铁速度', value: '1200km/h' }, { label: '日均出行', value: '500万次' }, { label: '事故率', value: '0' }],
    scenes: [
      { title: 'eVTOL空中走廊', desc: '城市上空划分为100个高度层，AI统一调度，每秒处理100万架次飞行请求', icon: 'ri-flight-takeoff-line' },
      { title: '磁悬浮地面网络', desc: '地面磁悬浮轨道覆盖全城，速度300km/h，完全无噪音无排放', icon: 'ri-train-line' },
      { title: '超级地下高铁', desc: '地下真空管道高铁，速度1200km/h，连接火星各大城市', icon: 'ri-subway-line' },
      { title: 'AI交通大脑', desc: '量子AI实时优化全城交通流，预测并消除拥堵，出行效率提升500%', icon: 'ri-brain-line' },
    ],
  },
  {
    id: 'life', label: '生活娱乐', icon: 'ri-gamepad-line', color: '#A855F7',
    title: '火星生活 · 高科技乌托邦',
    subtitle: 'Mars Life · Utopia 2065',
    desc: '在火星，人们享受着比地球更高质量的生活。元宇宙与现实完美融合，工作时间减少到每周20小时，其余时间用于创造和享乐。平均寿命达到150岁。',
    image: 'https://readdy.ai/api/search-image?query=Mars%20colony%20interior%20life%20people%20enjoying%20futuristic%20park%20green%20plants%20holographic%20entertainment%20happy%20lifestyle%20purple%20neon%20glow%20cinematic%208k&width=1200&height=600&seq=mars-life-bg-001&orientation=landscape',
    details: [{ label: '工作时长', value: '20小时/周' }, { label: '平均寿命', value: '150岁' }, { label: '幸福指数', value: '9.8/10' }, { label: '犯罪率', value: '0.001%' }],
    scenes: [
      { title: '元宇宙娱乐中心', desc: '全沉浸式元宇宙娱乐，可以体验地球任何历史时期，或探索宇宙任何角落', icon: 'ri-glasses-2-line' },
      { title: '零重力运动场', desc: '利用火星低重力区域，开展地球上不可能的极限运动，如真实飞行和超级跳跃', icon: 'ri-run-line' },
      { title: '星际旅游', desc: '定期开展地球-月球-火星旅游线路，以及木星、土星环游览项目', icon: 'ri-rocket-line' },
      { title: '数字永生服务', desc: '意识数字化技术让人类可以在虚拟世界中永生，与后代永远相伴', icon: 'ri-heart-line' },
    ],
  },
  {
    id: 'starlink', label: '火星星链', icon: 'ri-global-line', color: '#FFD700',
    title: '火星星链 · 宇宙互联网',
    subtitle: 'Mars Starlink · Solar Internet',
    desc: '围绕火星部署的360颗通信卫星网络，实现火星全球覆盖，并与地球星链网络连接，构建太阳系互联网基础设施。量子通信实现地火即时通信。',
    image: 'https://readdy.ai/api/search-image?query=Mars%20satellite%20network%20starlink%20constellation%20orbit%20red%20planet%20space%20communication%20network%20gold%20yellow%20glowing%20cinematic%208k%20ultra%20detailed&width=1200&height=600&seq=mars-starlink-bg-001&orientation=landscape',
    details: [{ label: '卫星数量', value: '360颗' }, { label: '轨道高度', value: '500km' }, { label: '通信延迟', value: '3-22分钟' }, { label: '带宽', value: '100Gbps' }],
    scenes: [
      { title: '火星全球覆盖', desc: '360颗卫星确保火星任何位置都有稳定的高速网络连接', icon: 'ri-global-line' },
      { title: '地火量子通信', desc: '利用量子纠缠技术，实现地球与火星之间的即时量子加密通信', icon: 'ri-cpu-line' },
      { title: '星际导航系统', desc: '为太阳系内所有飞船提供精确导航，精度达到厘米级', icon: 'ri-map-pin-line' },
      { title: '太阳系互联网', desc: '连接地球、月球、火星、木星基地，构建人类第一个星际互联网', icon: 'ri-links-line' },
    ],
  },
];

const TOUR_ROUTES = [
  { from: '地球', to: '月球', duration: '3天', price: '¥50万', color: '#00FFCC', stops: ['地球轨道空间站', '月球基地阿尔忒弥斯'], icon: 'ri-moon-line' },
  { from: '月球', to: '火星', duration: '6个月', price: '¥500万', color: '#FF6B35', stops: ['拉格朗日点补给站', '火星轨道空间站', '奥林匹斯城'], icon: 'ri-planet-line' },
  { from: '火星', to: '木星', duration: '2年', price: '¥5000万', color: '#A855F7', stops: ['小行星带矿业站', '木卫二海洋基地', '木星大红斑观测站'], icon: 'ri-rocket-line' },
  { from: '太阳系', to: '比邻星', duration: '100年', price: '待定', color: '#FFD700', stops: ['奥尔特云前哨站', '星际空间', '比邻星b行星'], icon: 'ri-star-line' },
];

const MARS_RESIDENTS = [
  { name: '林火星', job: '量子工程师', avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20man%20engineer%20portrait%20futuristic%20space%20suit%20background&width=80&height=80&seq=mars-r1&orientation=squarish', msg: '在火星生活了5年，这里的生活质量远超地球！元宇宙让我随时可以"回家"看望父母。最让我惊喜的是，火星的夜空——两个月亮同时升起的那一刻，我知道我做了正确的选择。', color: '#FF6B35' },
  { name: '张奥林', job: '垂直农业师', avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20woman%20scientist%20portrait%20futuristic%20lab%20background&width=80&height=80&seq=mars-r2&orientation=squarish', msg: '我负责管理第47号垂直农业大楼，AI帮我处理90%的工作，我只需要享受创造的乐趣。在火星种出第一颗草莓的那天，我哭了。', color: '#00FFCC' },
  { name: '王宇宙', job: 'eVTOL飞行员', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20pilot%20portrait%20futuristic%20cockpit%20background&width=80&height=80&seq=mars-r3&orientation=squarish', msg: '火星的天空是我的办公室，每天驾驶eVTOL穿梭于城市之间，感觉自己就是未来的一部分。在0.38G重力下飞行，那种轻盈感是地球上永远体验不到的。', color: '#A855F7' },
];

export default function MarsPage() {
  const navigate = useNavigate();
  const [activeZone, setActiveZone] = useState(MARS_ZONES[0]);
  const [selectedRoute, setSelectedRoute] = useState<typeof TOUR_ROUTES[0] | null>(null);
  const [selectedResident, setSelectedResident] = useState<typeof MARS_RESIDENTS[0] | null>(null);
  const [animIn, setAnimIn] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'META66火星城市 | 元宇宙火星移民·立体交通·星际旅游·火星星链';
    setTimeout(() => setAnimIn(true), 100);
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const stars: { x: number; y: number; r: number; alpha: number; speed: number }[] = [];
    for (let i = 0; i < 150; i++) {
      stars.push({ x: Math.random() * canvas.width, y: Math.random() * canvas.height, r: Math.random() * 1.5 + 0.3, alpha: Math.random() * 0.6 + 0.1, speed: Math.random() * 0.02 + 0.005 });
    }
    let animId: number;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(s => {
        s.alpha += s.speed;
        if (s.alpha > 0.8 || s.alpha < 0.1) s.speed = -s.speed;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${s.alpha})`;
        ctx.fill();
      });
      animId = requestAnimationFrame(animate);
    };
    animate();
    return () => cancelAnimationFrame(animId);
  }, []);

  return (
    <div className="min-h-screen overflow-hidden" style={{ background: 'linear-gradient(180deg, #020810 0%, #0A0408 50%, #020810 100%)', fontFamily: "'Inter', 'PingFang SC', sans-serif" }}>
      <canvas ref={canvasRef} className="fixed inset-0 pointer-events-none z-0" />

      {/* Fixed BG */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 opacity-4" style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255,107,53,0.15) 0%, transparent 40%), radial-gradient(circle at 80% 20%, rgba(255,107,53,0.08) 0%, transparent 40%)',
        }} />
      </div>

      {/* Header */}
      <div className="sticky top-0 z-50" style={{ background: 'rgba(2,8,16,0.95)', borderBottom: '1px solid rgba(255,107,53,0.2)', backdropFilter: 'blur(20px)' }}>
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 transition-all cursor-pointer whitespace-nowrap hover:scale-105" style={{ color: 'rgba(255,255,255,0.5)' }}>
            <i className="ri-arrow-left-line" />
            <span className="text-sm">返回首页</span>
          </button>
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center" style={{ background: 'rgba(255,107,53,0.2)', border: '1.5px solid rgba(255,107,53,0.5)', borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%' }}>
              <i className="ri-planet-line text-white text-sm" />
            </div>
            <span className="font-black text-white" style={{ fontFamily: 'Orbitron, sans-serif', fontSize: '0.9rem' }}>MARS CITY</span>
          </div>
          <div className="text-sm" style={{ color: 'rgba(255,107,53,0.7)', fontFamily: 'Caveat, cursive' }}>2065 · 星际移民</div>
        </div>
      </div>

      {/* Hero */}
      <div className="relative z-10 h-[520px] overflow-hidden">
        <img
          src={activeZone.image}
          alt={activeZone.title}
          className="w-full h-full object-cover object-top transition-all duration-1000"
          style={{ transform: `translateY(${scrollY * 0.25}px)` }}
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(2,8,16,0.2) 0%, rgba(2,8,16,0.5) 50%, rgba(2,8,16,1) 100%)' }} />
        <div className="absolute inset-0" style={{ background: `radial-gradient(ellipse at 30% 50%, ${activeZone.color}10 0%, transparent 60%)` }} />

        <div className="absolute inset-0 flex items-center px-8 md:px-16">
          <div style={{ opacity: animIn ? 1 : 0, transform: animIn ? 'translateX(0)' : 'translateX(-40px)', transition: 'all 0.9s ease' }}>
            <div className="inline-flex items-center gap-2 px-4 py-2 mb-5" style={{ background: `${activeZone.color}15`, border: `1.5px solid ${activeZone.color}40`, borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%' }}>
              <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: activeZone.color }} />
              <span className="text-sm font-bold" style={{ color: activeZone.color, fontFamily: 'Caveat, cursive', fontSize: '0.95rem' }}>{activeZone.subtitle}</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-black text-white mb-4 leading-tight" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              <span className="text-transparent bg-clip-text" style={{ backgroundImage: `linear-gradient(135deg, ${activeZone.color}, #FFD700)` }}>MARS</span>
            </h1>
            <h2 className="text-2xl md:text-3xl font-black text-white mb-4">{activeZone.title}</h2>
            <p className="text-white/55 text-lg max-w-2xl leading-relaxed">{activeZone.desc}</p>

            <div className="flex flex-wrap gap-4 mt-6">
              {activeZone.details.map(d => (
                <div key={d.label} className="px-4 py-2" style={{ background: 'rgba(2,8,16,0.7)', border: `1px solid ${activeZone.color}30`, borderRadius: '10px 8px 12px 8px / 8px 12px 8px 10px', backdropFilter: 'blur(10px)' }}>
                  <p className="font-black text-lg" style={{ color: activeZone.color, fontFamily: 'Orbitron, sans-serif' }}>{d.value}</p>
                  <p className="text-white/40 text-xs">{d.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Zone Tabs */}
        <div className="absolute bottom-0 left-0 right-0 flex">
          {MARS_ZONES.map(zone => (
            <button
              key={zone.id}
              onClick={() => setActiveZone(zone)}
              className="flex-1 py-4 text-sm font-bold transition-all duration-500 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              style={{
                background: activeZone.id === zone.id ? `${zone.color}25` : 'rgba(2,8,16,0.8)',
                color: activeZone.id === zone.id ? zone.color : 'rgba(255,255,255,0.35)',
                borderTop: `2px solid ${activeZone.id === zone.id ? zone.color : 'transparent'}`,
                backdropFilter: 'blur(10px)',
                fontFamily: 'Caveat, cursive',
                fontSize: '0.95rem',
              }}
            >
              <i className={zone.icon} />
              <span className="hidden sm:inline">{zone.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-16">

        {/* Zone Scenes */}
        <div className="mb-20">
          <div className="flex items-center gap-4 mb-10">
            <div className="h-px flex-1" style={{ background: `linear-gradient(90deg, transparent, ${activeZone.color}40)` }} />
            <h2 className="text-3xl font-black text-white whitespace-nowrap" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              <span style={{ color: activeZone.color }}>核心场景</span>
            </h2>
            <div className="h-px flex-1" style={{ background: `linear-gradient(90deg, ${activeZone.color}40, transparent)` }} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {activeZone.scenes.map((scene, i) => (
              <div
                key={scene.title}
                className="group p-6 rounded-2xl transition-all duration-400 hover:-translate-y-3"
                style={{
                  background: `${activeZone.color}06`,
                  border: `1.5px solid ${activeZone.color}20`,
                  borderRadius: '18px 14px 20px 16px / 14px 20px 16px 18px',
                  opacity: animIn ? 1 : 0,
                  transform: animIn ? 'translateY(0)' : 'translateY(30px)',
                  transition: `all 0.6s ease ${i * 100}ms`,
                }}
              >
                <div
                  className="w-14 h-14 flex items-center justify-center mb-5 transition-all duration-300 group-hover:scale-110"
                  style={{ background: `${activeZone.color}15`, border: `2px solid ${activeZone.color}35`, borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%' }}
                >
                  <i className={`${scene.icon} text-2xl`} style={{ color: activeZone.color }} />
                </div>
                <h3 className="text-white font-bold text-base mb-2">{scene.title}</h3>
                <p className="text-white/45 text-sm leading-relaxed">{scene.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Residents + Tour Routes */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-20">
          {/* Residents */}
          <div
            className="p-8 rounded-3xl"
            style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,107,53,0.15)', borderRadius: '24px 18px 28px 20px / 18px 28px 20px 24px' }}
          >
            <h3 className="text-white font-black text-xl mb-6 flex items-center gap-3" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              <i className="ri-user-voice-line" style={{ color: '#FF6B35' }} />
              与火星居民对话
            </h3>
            <div className="flex flex-col gap-4">
              {MARS_RESIDENTS.map(r => (
                <div
                  key={r.name}
                  className="flex items-center gap-4 p-4 rounded-xl cursor-pointer transition-all duration-300 hover:-translate-y-1"
                  style={{ background: `${r.color}06`, border: `1px solid ${r.color}20`, borderRadius: '12px 8px 14px 10px / 8px 14px 10px 12px' }}
                  onClick={() => setSelectedResident(r)}
                >
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0" style={{ border: `2px solid ${r.color}40` }}>
                    <img src={r.avatar} alt={r.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-white font-bold text-base">{r.name}</p>
                    <p className="text-white/40 text-sm">{r.job}</p>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <div className="w-8 h-8 flex items-center justify-center" style={{ background: `${r.color}15`, borderRadius: '50%', color: r.color }}>
                      <i className="ri-chat-1-line text-sm" />
                    </div>
                    <Link
                      to="/mars/life"
                      onClick={e => e.stopPropagation()}
                      className="px-3 py-1.5 text-xs font-bold rounded-lg whitespace-nowrap transition-all hover:scale-105"
                      style={{ background: `${r.color}20`, border: `1px solid ${r.color}40`, color: r.color }}
                    >
                      深度解析 →
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mars Stats */}
          <div
            className="p-8 rounded-3xl"
            style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,215,0,0.15)', borderRadius: '24px 18px 28px 20px / 18px 28px 20px 24px' }}
          >
            <h3 className="text-white font-black text-xl mb-6" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              <span style={{ color: '#FFD700' }}>火星</span> 关键数据
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {[
                { label: '火星城市数量', value: '12座', color: '#FF6B35', icon: 'ri-building-4-line' },
                { label: '移民总人口', value: '500万', color: '#00FFCC', icon: 'ri-group-line' },
                { label: '年旅游人次', value: '100万', color: '#A855F7', icon: 'ri-rocket-line' },
                { label: '建设总投资', value: '$100万亿', color: '#FFD700', icon: 'ri-money-dollar-circle-line' },
              ].map(stat => (
                <div key={stat.label} className="p-4 rounded-xl text-center" style={{ background: `${stat.color}08`, border: `1px solid ${stat.color}20`, borderRadius: '12px 8px 14px 10px / 8px 14px 10px 12px' }}>
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2" style={{ background: `${stat.color}15`, borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%' }}>
                    <i className={`${stat.icon} text-lg`} style={{ color: stat.color }} />
                  </div>
                  <p className="font-black text-xl text-white mb-1" style={{ fontFamily: 'Orbitron, sans-serif', color: stat.color }}>{stat.value}</p>
                  <p className="text-white/40 text-xs">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Tour Routes */}
        <div className="mb-16">
          <div className="flex items-center gap-4 mb-10">
            <div className="h-px flex-1" style={{ background: 'linear-gradient(90deg, transparent, rgba(255,107,53,0.4))' }} />
            <h2 className="text-3xl font-black text-white whitespace-nowrap" style={{ fontFamily: 'Orbitron, sans-serif' }}>星际旅游线路</h2>
            <div className="h-px flex-1" style={{ background: 'linear-gradient(90deg, rgba(255,107,53,0.4), transparent)' }} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {TOUR_ROUTES.map((route, i) => (
              <div
                key={route.from + route.to}
                className="group p-6 rounded-2xl cursor-pointer transition-all duration-400 hover:-translate-y-3"
                style={{
                  background: `${route.color}06`,
                  border: `1.5px solid ${route.color}25`,
                  borderRadius: '18px 14px 20px 16px / 14px 20px 16px 18px',
                  opacity: animIn ? 1 : 0,
                  transform: animIn ? 'translateY(0)' : 'translateY(30px)',
                  transition: `all 0.6s ease ${i * 100}ms`,
                }}
                onClick={() => setSelectedRoute(route)}
              >
                <div className="w-12 h-12 flex items-center justify-center mb-4" style={{ background: `${route.color}15`, border: `2px solid ${route.color}35`, borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%' }}>
                  <i className={`${route.icon} text-xl`} style={{ color: route.color }} />
                </div>
                <div className="flex items-center gap-2 mb-4">
                  <span className="text-white font-bold text-base">{route.from}</span>
                  <i className="ri-arrow-right-line text-xs" style={{ color: route.color }} />
                  <span className="text-white font-bold text-base">{route.to}</span>
                </div>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between text-sm">
                    <span className="text-white/40">旅行时长</span>
                    <span className="text-white/70 font-medium">{route.duration}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-white/40">参考价格</span>
                    <span className="font-black" style={{ color: route.color }}>{route.price}</span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-white/30 text-xs">{route.stops.length}个途经站点</p>
                  <Link
                    to="/mars/starlink"
                    onClick={e => e.stopPropagation()}
                    className="px-3 py-1.5 text-xs font-bold rounded-lg whitespace-nowrap transition-all hover:scale-105"
                    style={{ background: `${route.color}20`, border: `1px solid ${route.color}40`, color: route.color }}
                  >
                    深度解析 →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Resident Modal */}
      {selectedResident && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(20px)' }} onClick={() => setSelectedResident(null)}>
          <div className="w-full max-w-md p-8" style={{ background: '#060C18', border: `2px solid ${selectedResident.color}40`, borderRadius: '24px 18px 28px 20px / 18px 28px 20px 24px' }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-full overflow-hidden" style={{ border: `3px solid ${selectedResident.color}50` }}>
                <img src={selectedResident.avatar} alt={selectedResident.name} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <p className="text-white font-black text-xl">{selectedResident.name}</p>
                <p className="text-xs px-3 py-1 inline-block mt-1" style={{ background: `${selectedResident.color}15`, color: selectedResident.color, borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%', fontFamily: 'Caveat, cursive' }}>{selectedResident.job} · 奥林匹斯城</p>
              </div>
            </div>
            <div className="p-5 rounded-xl mb-6" style={{ background: `${selectedResident.color}06`, border: `1px solid ${selectedResident.color}20` }}>
              <p className="text-white/70 leading-relaxed" style={{ fontFamily: 'Caveat, cursive', fontSize: '1rem', lineHeight: '1.8' }}>"{selectedResident.msg}"</p>
            </div>
            <button onClick={() => setSelectedResident(null)} className="w-full py-3 font-black text-black cursor-pointer whitespace-nowrap" style={{ background: selectedResident.color, borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%', fontFamily: 'Caveat, cursive', fontSize: '1rem' }}>感谢分享！</button>
          </div>
        </div>
      )}

      {/* Route Modal */}
      {selectedRoute && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(20px)' }} onClick={() => setSelectedRoute(null)}>
          <div className="w-full max-w-md p-8" style={{ background: '#060C18', border: `2px solid ${selectedRoute.color}40`, borderRadius: '24px 18px 28px 20px / 18px 28px 20px 24px' }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center" style={{ background: `${selectedRoute.color}15`, border: `2px solid ${selectedRoute.color}40`, borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%' }}>
                <i className={`${selectedRoute.icon} text-xl`} style={{ color: selectedRoute.color }} />
              </div>
              <div>
                <h2 className="text-white font-black text-xl">{selectedRoute.from} → {selectedRoute.to}</h2>
                <p className="text-white/40 text-sm">星际旅游线路</p>
              </div>
            </div>
            <div className="flex flex-col gap-3 mb-6">
              {selectedRoute.stops.map((stop, i) => (
                <div key={stop} className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center text-xs font-black text-black flex-shrink-0" style={{ background: selectedRoute.color, borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%' }}>{i + 1}</div>
                  <span className="text-white/70 text-sm">{stop}</span>
                </div>
              ))}
            </div>
            <div className="flex justify-between items-center p-4 rounded-xl mb-6" style={{ background: `${selectedRoute.color}08`, border: `1px solid ${selectedRoute.color}20` }}>
              <div>
                <p className="text-white/40 text-xs">旅行时长</p>
                <p className="text-white font-bold">{selectedRoute.duration}</p>
              </div>
              <div className="text-right">
                <p className="text-white/40 text-xs">参考价格</p>
                <p className="font-black text-2xl" style={{ color: selectedRoute.color, fontFamily: 'Orbitron, sans-serif' }}>{selectedRoute.price}</p>
              </div>
            </div>
            <button onClick={() => setSelectedRoute(null)} className="w-full py-3 font-black text-black cursor-pointer whitespace-nowrap" style={{ background: selectedRoute.color, borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%', fontFamily: 'Caveat, cursive', fontSize: '1rem' }}>立即预订</button>
          </div>
        </div>
      )}
    </div>
  );
}
